'use strict';
var $ = require('jquery');
$(function() {
    function navigationOnScroll(){
        if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
            $('.lang-selection').addClass('hide-lang');
        }
    };
    navigationOnScroll();
    $(window).on('scroll', function(){
        navigationOnScroll();
    });

    $('.mobile-nav-trigger').on('click', function(){
        $('.mobile-nav-trigger').toggleClass('is-active');
        $('.mobile-navigation').toggleClass('open');
        $('.search-box').removeClass('open');
    });
    $('.mobile-sidenav-trigger').on('click', function(){
        $('.mobile-sidenav-trigger').toggleClass('is-active');
        $('#product-nav').toggleClass('open');
        $('#childpage-nav').toggleClass('open');
    });
    $('.lang-trigger').on('click', function(){
        $('.lang-icon').toggleClass('active');
        if($('.lang-selection').hasClass('hide-lang')){
            $('.lang-selection').removeClass('hide-lang');
            $('.search-box').removeClass('open');
        }else{
            $('.lang-selection').addClass('hide-lang');
        }
    });

    
    $('.mobile-child-button').on('click', function(){
        
        $('.mobile-children').not($(this).parent().next()).removeClass('child-open');
        $(this).parent().next().toggleClass('child-open');
        
        if($(this).hasClass('active-mobile-button')){
            $(this).removeClass('active-mobile-button')
        }else{
            $(this).addClass('active-mobile-button')
        }
        $('.mobile-child-button').not(this).removeClass('active-mobile-button')

    });


    $('.open-search').on('click', function(){
        $('.search-box').addClass('open');
        $('.mobile-nav-trigger').removeClass('is-active');
        $('.mobile-navigation').removeClass('open');
        $('.lang-selection').addClass('hide-lang');
    });
    $('.close-search').on('click', function(){
        $('.search-box').removeClass('open');
    });
});
